(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.vqfDownloads = {
    attach: function (context) {
      // Get the submit button element within the given context
      const submitButton = $(context).find('input#edit-submit-vqf-downloads').get(0);

      // Check if the submit button exists within the context
      if (submitButton) {
        // Add a click event listener to the submit button, ensuring it's only added once
        $(submitButton).once('vqfDownloadsClick').on('click', function() {
          const inputElement = document.querySelector('#edit-combine');
          const parentElement = inputElement.parentElement;

          if (parentElement) {
            const iconSpan = document.createElement('span');
            iconSpan.classList.add('uk-form-icon', 'uk-icon');
            iconSpan.setAttribute('uk-icon', 'icon: search');

            parentElement.style.position = 'relative'; // Ensure parent is positioned

            // Insert the icon before the input
            parentElement.insertBefore(iconSpan, inputElement);

            // Add appropriate padding to the input
            inputElement.style.paddingLeft = '30px'; // Adjust based on icon size and desired spacing

          }

          const accordions = $(context).find('.uk-accordion');
          const accordionContents = $(context).find('.uk-accordion-content');

          accordionContents.each(function() {
            $(this).removeAttr('hidden');
          });
          accordions.each(function() {
            $(this).addClass('uk-open');
            const accordionTitles = $(this).find('a'); // Common trigger elements

            accordionTitles.each(function() {
              $(this).attr('aria-expanded', true);
            });
          });
        });
      }

      // Additionally, re-check and open accordions in the new context after AJAX
      const accordions = $(context).find('.uk-accordion');
      const accordionContents = $(context).find('.uk-accordion-content');
      const defaultButton = $(context).find('.uk-button-default'); // Find the default button



      accordionContents.each(function() {
        $(this).removeAttr('hidden');
      });
      accordions.each(function() {
        $(this).addClass('uk-open');
        const accordionTitles = $(this).find('a');

        accordionTitles.each(function() {
          $(this).attr('aria-expanded', true);
        });
      });

      // Add the secondary class to the default button after AJAX
      if (defaultButton.length) {
        defaultButton.addClass('uk-button-secondary');
      }
    }
  };
})(Drupal, jQuery);
